import React from 'react';
import { Link } from 'react-router-dom';
import SmartImage from '@/components/SmartImage';

export const WaveBicoloreShowcase = ({ language, products, variant = 'collection' }) => {
  const isItalian = language === 'it';
  const isHome = variant === 'home';
  const rings = products.slice(0, 4);
  const copy = isItalian
    ? {
      overline: 'Nuovi arrivi',
      title: 'Linea Wave Bicolore',
      availability: 'Disponibilità limitata',
      price: '€ 1.700',
      discover: 'Scopri il gioiello',
    }
    : {
      overline: 'New arrivals',
      title: 'Linea Wave Bicolore',
      availability: 'Limited availability',
      price: '€ 1,700',
      discover: 'Discover the jewel',
    };

  if (!rings.length) return null;

  return (
    <section id="wave-bicolore-showcase" className={`relative isolate scroll-mt-28 overflow-hidden ${isHome ? 'py-12 md:py-16' : 'py-16 md:py-24'}`} data-testid={`wave-bicolore-showcase-${variant}`}>
      <div className="pointer-events-none absolute inset-0 z-0 bg-[#E7C9C6]" data-testid="wave-bicolore-pink-band" />
      <div className={`relative z-10 mx-auto px-6 md:px-12 lg:px-24 ${isHome ? 'max-w-[1160px]' : 'max-w-[1400px]'}`}>
        <div className={`text-center ${isHome ? 'mb-8 md:mb-10' : 'mb-12 md:mb-16'}`}>
          <div className={`overline text-[#C58F9B] ${isHome ? 'mb-3' : 'mb-5'}`} data-testid="wave-bicolore-showcase-overline">{copy.overline}</div>
          <h2 className={`font-serif font-light text-[#171517] leading-[1.05] ${isHome ? 'text-3xl md:text-4xl' : 'text-4xl md:text-5xl'}`} data-testid="wave-bicolore-showcase-title">{copy.title}</h2>
          <div className={`divider-gold mx-auto ${isHome ? 'my-5' : 'my-7'}`} />
          <p className="overline text-[#171517]" data-testid="wave-bicolore-showcase-availability">{copy.availability}</p>
        </div>
        <div className={`grid grid-cols-2 lg:grid-cols-4 ${isHome ? 'gap-x-3 gap-y-6 md:gap-x-5' : 'gap-x-4 gap-y-10 md:gap-x-6'}`} data-testid={`wave-bicolore-gallery-${variant}`}>
          {rings.map((product, index) => {
              const image = product.images?.[0];
              const name = product.translations?.[language]?.name || product.translations?.it?.name || product.sku;
              const caption = product.translations?.[language]?.description || product.translations?.it?.description || '';
              return (
                <article key={product.id} className={`relative z-10 min-w-0 overflow-hidden bg-white text-center ${isHome ? 'mx-auto w-full max-w-[248px]' : ''}`} data-testid={`wave-bicolore-card-${product.slug}`}>
                  <Link to={`/prodotto/${product.slug}`} className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A961]" aria-label={`${copy.discover}: ${name}`} data-testid={`wave-bicolore-image-link-${variant}-${index}`}>
                    <div className="relative aspect-square w-full overflow-hidden bg-white">
                      <SmartImage src={image} alt={name} sizes="(min-width: 1024px) 21vw, 45vw" className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" />
                    </div>
                  </Link>
                  <div className={`bg-white shadow-[0_10px_24px_rgba(23,21,23,0.08)] ${isHome ? 'mt-3 px-3 py-3' : 'mt-5 px-4 py-5'}`} data-testid={`wave-bicolore-details-${variant}-${product.slug}`}>
                    <h3 className={`font-serif text-[#171517] ${isHome ? 'text-lg md:text-xl' : 'text-2xl'}`} data-testid={`wave-bicolore-name-${variant}-${product.slug}`}>{name}</h3>
                    {!isHome && caption && <p className="mt-2 text-sm leading-relaxed text-[#4A4A4A]" data-testid={`wave-bicolore-caption-${product.slug}`}>{caption}</p>}
                    <p className={`font-serif text-[#171517] ${isHome ? 'mt-3 text-lg md:text-xl' : 'mt-5 text-2xl'}`} data-testid={`wave-bicolore-price-${variant}-${product.slug}`}>{copy.price}</p>
                    {!isHome && <p className="mt-1 text-xs text-[#4A4A4A]" data-testid={`wave-bicolore-inclusions-${variant}-${product.slug}`}>{isItalian ? 'IVA e spedizione incluse' : 'VAT and shipping included'}</p>}
                    <Link to={`/prodotto/${product.slug}`} className={`btn-outline-petrol flex w-full items-center justify-center ${isHome ? 'mt-3 !px-3 !py-2 text-[9px]' : 'mt-5'}`} data-testid={`wave-bicolore-details-link-${variant}-${product.slug}`}>{copy.discover}</Link>
                  </div>
                </article>
              );
            })}
        </div>
      </div>

    </section>
  );
};